import React from 'react';

let faqNL = ({onMenuToggle}) => {
	return <div>
		<h2>Aan de slag met Enjoy!</h2>
		<div className="faq-warning">
			<p>Premium Club en Bizz Club stoppen op 30/11/2019.<br/> U kunt tot 30/11/19 uw <a
				href="http://www.proximus.be/support/nl/id_sfaqr_club_exchange/particulieren/support/myproximus-en-facturen/premium-club/premium-club-punten/premium-club-punten-raadplegen-en-inruilen.html">Premium
				Club-punten inruilen</a> of, als professionele klant, uw <a
				href="http://www.proximus.be/support/nl/id_sfaqs_club_exchange/zelfstandigen-en-kleine-bedrijven/support/myproximus-en-facturen/bizz-club/bizz-club-punten/bizz-club-punten-raadplegen-en-inruilen.html">Bizz
				Club-punten inruilen</a>.</p>
		</div>
		<p>Premium Club en Bizz Club maken plaats voor Enjoy! U vindt als Proximus-klant in MyProximus twee soorten
			exclusieve voordelen: Enjoy! experiences en Enjoy! deals.</p>
		<h2 id="howto">Hoe Enjoy! raadplegen?</h2>
		<p>Om de aanbiedingen en wedstrijden van Enjoy! te kunnen zien, moet u <a
			href="https://www.proximus.be/support/nl/id_sfaqs_mypx_register/zelfstandigen-en-kleine-bedrijven/support/myproximus-en-facturen/myproximus/myproximus-applicatie/hoe-inschrijven-op-myproximus.html">ingeschreven
			zijn </a>&eacute;n <a
			href="https://www.proximus.be/support/nl/id_sfaqr_mypx_login/particulieren/support/myproximus-en-facturen/myproximus/myproximus-website/hoe-inloggen-op-myproximus.html">ingelogd
			zijn</a> op MyProximus. <a
			href="https://www.proximus.be/support/nl/id_sfaqs_mypx_no_access/zelfstandigen-en-kleine-bedrijven/support/myproximus-en-facturen/myproximus/myproximus-website/geen-toegang-tot-myproximus.html">Lukt
			inschrijven of inloggen niet?</a></p>
		<p>Bekijk vervolgens de aanbiedingen van Enjoy! via MyProximus (via de app en via het web):</p>
		<ol>
			<li>Via de app: Tik in de MyProximus-app op Meer en vervolgens op Mijn voordelen.<br/> Via de website: Klik
				op onderstaande knop en meld u aan.<br/> <a
					href="https://www.proximus.be/myproximus/en/Personal/services/My-Rewards__.html">Bekijk Enjoy!</a>
			</li>
			<li>Klik op Enjoy! experiences of op Enjoy! deals:
				<ul>
					<li>Enjoy! experiences: Doe mee met een of meerdere wedstrijden. Winnaars worden per e-mail
						verwittigd.
					</li>
					<li>Enjoy! deals: Geniet van het wisselende aanbod. Kijk goed na hoe lang uw korting of voordeel
						geldig is. U kunt het slechts &eacute;&eacute;n keer gebruiken.
					</li>
				</ul>
			</li>
		</ol>
		<h2>Lukt het niet of is er een probleem?</h2>
		<p>Ga na wat uw situatie is. We helpen u graag verder.</p>
		<div className="panel-group" id="accordion">
			<div className="panel panel-default">
				<div className="panel-heading">
					<a className="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapseOne">
						U vindt Enjoy! niet terug of u hebt geen toegang
					</a>
				</div>
				<div id="collapseOne" className="panel-collapse collapse in">
					<p>Ga na of u in deze situatie bent:</p>
					<ul>
						<li>Als u bovenaan in MyProximus niet uw naam ziet staan, bent u niet correct <a
							href="https://www.proximus.be/support/nl/id_sfaqr_mypx_login/particulieren/support/myproximus-en-facturen/myproximus/myproximus-website/hoe-inloggen-op-myproximus.html">aangemeld</a> of <a
							href="https://www.proximus.be/support/nl/id_sfaqs_mypx_register/zelfstandigen-en-kleine-bedrijven/support/myproximus-en-facturen/myproximus/myproximus-applicatie/hoe-inschrijven-op-myproximus.html">ingeschreven</a>.
						</li>
						<li>Wordt uw gsm via het werk betaald, dan kunt u niet deelnemen aan Enjoy!</li>
						<li>U moet ouder zijn dan 18 jaar.</li>
					</ul>
				</div>
			</div>

			<div className="panel panel-default">
				<div className="panel-heading">
					<a className="accordion-toggle" data-toggle="collapse" data-parent="#accordion" href="#collapseTwo">
						U kunt niet meer meedoen aan een bepaalde Enjoy! deal of Enjoy! experience?
					</a>
				</div>
				<div id="collapseTwo" className="panel-collapse collapse in">
					<p>Enjoy! deals en Enjoy! experiences zijn beperkt in tijd &eacute;n in volume. Snel zijn is dus de
						boodschap. Wie eerst komt, wordt eerst bediend. Maar er komen regelmatig nieuwe deals bij.
						Raadpleeg daarom regelmatig Enjoy! zoals <a href="#howto">hierboven</a> uitgelegd.</p>
				</div>
			</div>

			<div className="panel panel-default">
				<div className="panel-heading">
					<a className="accordion-toggle" data-toggle="collapse" data-parent="#accordion"
					   href="#collapseThree">
						U vindt de code, voucher of link voor uw Enjoy! deal niet meer terug?
					</a>
				</div>
				<div id="collapseThree" className="panel-collapse collapse in">
					<p>U kunt deze informatie tot haar vervaldatum terugvinden via MyProximus. Ga als volgt te werk:</p>
					<ol>
						<li>Raadpleeg Enjoy! zoals <a href="#howto">hierboven</a></li>
						<li>Klik op uw Enjoy! deal. Daar vindt u de code, voucher of link terug.</li>
					</ol>
					<p>U kunt uw korting of voordeel tot de vervaldatum de code slechts 1 keer gebruiken en niet
						combineren.</p>
				</div>
			</div>

			<div className="panel panel-default">
				<div className="panel-heading">
					<a className="accordion-toggle" data-toggle="collapse" data-parent="#accordion"
					   href="#collapseFour">
						Uw code voor een Enjoy! deal werkt niet?
					</a>
				</div>
				<div id="collapseFour" className="panel-collapse collapse in">
					<p>Eens de code gebruikt is of eens de vervaldatum van de code overschreden is, werkt deze niet
						meer. Werkt echter v&oacute;&oacute;r de vervaldatum uw code niet, neem dan <a
							href="http://www.proximus.be/contact">contact</a> op per chat of per e-mail. Houd uw <a
							href="https://www.proximus.be/support/nl/id_sfaqr_mypx_credentials/particulieren/support/myproximus-en-facturen/myproximus/myproximus-website/klantnummer-activeringscode-en-datum.html">klantnummer</a> bij
						de hand. </p>
				</div>
			</div>

			<div className="panel panel-default">
				<div className="panel-heading">
					<a className="accordion-toggle" data-toggle="collapse" data-parent="#accordion"
					   href="#collapseFive">
						U hebt de winnende tickets van uw Enjoy! experience niet ontvangen?
					</a>
				</div>
				<div id="collapseFive" className="panel-collapse collapse in">
					<p>Neem <a href="http://www.proximus.be/contact">contact</a> op per chat of per e-mail. Houd uw <a
						href="https://www.proximus.be/support/nl/id_sfaqr_mypx_credentials/particulieren/support/myproximus-en-facturen/myproximus/myproximus-website/klantnummer-activeringscode-en-datum.html">klantnummer</a> bij
						de hand. </p>
				</div>
			</div>

		</div>
	</div>
};

export default faqNL;